module.exports = __webpack_public_path__ + "static/media/adopting-user1.55ba62a7.png";